import {
  BookingSessionBlockBookingStatus,
  BookingSessionBlockReason,
  BookingSessionBlockStatus,
} from '../../models/bookings';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

type AffectedSessionBlockReservationType = 'BOOKING' | 'QUEUE';

export type AffectedSessionBlockReservationStatus =
  | BookingSessionBlockBookingStatus
  | 'RELEASED';

interface IListAffectedSessionBlockReservationsServiceProps {
  activityId?: string;
  impactStatus?: AffectedSessionBlockReservationStatus;
  limit?: number;
  page?: number;
  type?: AffectedSessionBlockReservationType;
  userId?: string;
}

export interface IAffectedSessionBlockReservation {
  activity: {
    id: string;
    name: string;
  };
  block: {
    blockedDate: string;
    customReason?: string | null;
    id: string;
    notificationMessage: string;
    reason: BookingSessionBlockReason;
    status: BookingSessionBlockStatus;
    unblockedAt?: string | null;
  };
  id: string;
  impactStatus: AffectedSessionBlockReservationStatus;
  modality?: {
    id: string;
    title: string;
  } | null;
  reservation: {
    bookedAt?: string | null;
    bookedDate: string;
    createdAt: string;
    deletedAt?: string | null;
    endTime: string;
    id: string;
    price?: number | null;
    startTime: string;
    status: AffectedSessionBlockReservationStatus;
  };
  schedule: {
    endTime: string;
    id: string;
    minUserExperience: number;
    startTime: string;
    totalVacancies?: number | null;
    waveSide?: 'COMBO' | 'LEFT' | 'RIGHT' | null;
  };
  spot: {
    id: string;
    name: string;
  };
  type: AffectedSessionBlockReservationType;
  user: {
    cpf?: string | null;
    experience?: number | null;
    id: string;
    name: string;
  };
}

type Response = IListResponse<IAffectedSessionBlockReservation>;

export async function listAffectedSessionBlockReservationsService(
  filters?: IListAffectedSessionBlockReservationsServiceProps,
): Promise<Response> {
  const { data } = await jhsfBookingsApi.get<Response>(
    '/activities/session-blocks/affected-reservations',
    {
      params: {
        activityId: filters?.activityId,
        impactStatus: filters?.impactStatus,
        limit: filters?.limit,
        page: filters?.page,
        type: filters?.type,
        userId: filters?.userId,
      },
    },
  );

  return data;
}
